//*** env DEV */
// export const BASE_URL = 'https://web.dev.marcadores247.com';
// export const API_BASE = 'https://core-api.dev.marcadores247.com';

// export const API_BO_URL_MATCHES =
//   'https://backoffice-api.dev.marcadores247.com/sitemap/matches';

//*** env PROD */
export const BASE_URL = 'https://marcadores247.com';
export const API_BASE = 'https://api.marcadores247.com';
export const API_BO_URL_MATCHES =
  'https://bo-api.marcadores247.com/sitemap/matches';

export function normalizeRoute(route: string) {
  return route
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ñ/g, 'n')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/--+/g, '-')
    .toLowerCase();
}

const handleFormatDateYYYYMMDD = (data: Date) => {
  const date = new Date(data);

  const year = date.getFullYear();
  const day = String(date.getDate()).padStart(2, '0'); // Día (con 0 a la izquierda)
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Mes (0 = Enero, por eso +1)

  const formatted = `${year}-${day}-${month}`;
  return formatted;
};

export const createUrl = (
  loc: string,
  lastmod?: Date,
  changefreq = 'daily',
  priority = '0.8'
) => {
  return `
  <url>
    <loc>${loc}</loc>
    ${lastmod ? `<lastmod>${handleFormatDateYYYYMMDD(lastmod)}</lastmod>` : ''}
    <changefreq>${changefreq}</changefreq>
    <priority>${priority}</priority>
  </url>`;
};
